module.exports = __webpack_public_path__ + "img/performance.b6fdaf35.svg";